var _defs, _path, _path2, _path3, _path4, _rect, _path5, _polygon, _path6, _path7, _path8, _path9, _path10, _path11, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _path12;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 297.54 84.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#424379;}.c{fill:#999;}.d{fill:#c30d23;}.e{fill:#006934;}.f{fill:#f8b62d;}.g{fill:#0068b7;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M258,40.72a11.59,11.59,0,0,0-8.69,3.74,12.43,12.43,0,0,0-3.64,9.07,13,13,0,0,0,1.66,6.4,11.81,11.81,0,0,0,4.47,4.56,12.74,12.74,0,0,0,12.4,0,11.74,11.74,0,0,0,4.47-4.56,12.84,12.84,0,0,0,1.66-6.4,12.37,12.37,0,0,0-3.66-9.07A11.58,11.58,0,0,0,258,40.72Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M194.62,41.82a12.54,12.54,0,0,0-5.38-1.2,11.47,11.47,0,0,0-8,3,12.73,12.73,0,0,0-3.35,5.49h22.86a12.51,12.51,0,0,0-2.08-4.17A11.14,11.14,0,0,0,194.62,41.82Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M124.57,54.32c-.18.43-.49.43-.67,0L106.24,13.16a1.41,1.41,0,0,0-1.19-.79H98.71a.53.53,0,0,0-.52.79l24.5,57.11a1.41,1.41,0,0,0,1.19.78h.65a1.4,1.4,0,0,0,1.19-.78l24.85-57.12a.52.52,0,0,0-.51-.78h-6.35a1.43,1.43,0,0,0-1.19.78Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M159.27,21.76a4.43,4.43,0,0,0-3.11,7.55,4.41,4.41,0,0,0,7.53-3.11,4.42,4.42,0,0,0-4.42-4.44Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 156.26,
    y: 35.64,
    width: 6.04,
    height: 35.41
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M207.52,53.68a19.15,19.15,0,0,0-3.91-12,17.51,17.51,0,0,0-14.43-6.86,17,17,0,0,0-14,6.71,19,19,0,0,0-4.12,12,19.18,19.18,0,0,0,4.86,12.78c3.25,3.78,7.81,5.7,13.54,5.7a19.43,19.43,0,0,0,7-1.19A17.32,17.32,0,0,0,202,67.26a20.66,20.66,0,0,0,4.34-5.94l.38-.75-5.11-2.68-.41.69a19.85,19.85,0,0,1-3.52,4.58,12.6,12.6,0,0,1-3.88,2.22,13.62,13.62,0,0,1-4.72.84,11,11,0,0,1-8.35-3.5,12.68,12.68,0,0,1-3.48-8.18h30.3Zm-29.6-4.59a12.73,12.73,0,0,1,3.35-5.49,11.47,11.47,0,0,1,8-3,12.54,12.54,0,0,1,5.38,1.2,11.14,11.14,0,0,1,4.08,3.1,12.51,12.51,0,0,1,2.08,4.17Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "210.96 35.64 210.96 41.15 227.53 41.15 208.46 71.05 236.8 71.05 236.8 65.51 219.03 65.51 238.12 35.64 210.96 35.64"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M258,34.77a17.57,17.57,0,0,0-13.57,5.95,18.93,18.93,0,0,0,.27,25.64,18.68,18.68,0,0,0,26.58,0,18.95,18.95,0,0,0,.27-25.68A17.58,17.58,0,0,0,258,34.77Zm10.66,25.16a11.74,11.74,0,0,1-4.47,4.56,12.74,12.74,0,0,1-12.4,0,11.81,11.81,0,0,1-4.47-4.56,13,13,0,0,1-1.66-6.4,12.43,12.43,0,0,1,3.64-9.07,11.94,11.94,0,0,1,17.36,0,12.37,12.37,0,0,1,3.66,9.07A12.84,12.84,0,0,1,268.63,59.93Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M290.25,28.65a1.55,1.55,0,0,1,.69-.72,3.19,3.19,0,0,1,1.66-.38,10,10,0,0,1,3.75.95l1.19.51V22.84l-.61-.18a19.22,19.22,0,0,0-5.29-.9,8.31,8.31,0,0,0-4.3,1.06,6.22,6.22,0,0,0-2.61,2.89,15,15,0,0,0-.73,5.51v4.42h-4.43v5.45H284v30h6l0-30h7.05V35.64h-7V31.93A13.93,13.93,0,0,1,290.25,28.65Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M19.94,8a34.1,34.1,0,0,1-6.17,8.26c-2.46,2.46-4.14,3.52-5.25,4L28.81,28.9Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M76.41,19.9a33.84,33.84,0,0,1-8.27-6.17c-2.52-2.53-3.57-4.23-4-5.33L55.39,28.81Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M64.59,76.89a34.5,34.5,0,0,1,6.06-8C74.11,65.38,76,64.68,77,64.62L55.48,55.39Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M7.59,64.52a33.39,33.39,0,0,1,8.81,6.63A18.75,18.75,0,0,1,20.08,76L28.9,55.48Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "57.1 0 51.53 0 42.08 23.35 32.76 0 27.2 0 41.97 36.23 57.1 0"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "27.2 84.29 32.76 84.29 42.21 60.94 51.53 84.29 57.1 84.29 42.32 48.07 27.2 84.29"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "22.91 1.77 18.98 5.71 19.94 7.98 28.81 28.9 8.52 20.19 5.71 18.98 1.77 22.91 37.84 38.08 22.91 1.77"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "61.38 82.52 65.31 78.58 64.59 76.89 55.48 55.39 76.97 64.62 78.58 65.31 82.52 61.38 46.46 46.21 61.38 82.52"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "0 27.2 0 32.76 23.35 42.21 0 51.53 0 57.1 36.23 42.32 0 27.2"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "84.29 57.1 84.29 51.53 60.94 42.08 84.29 32.76 84.29 27.2 48.07 41.97 84.29 57.1"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "1.77 61.38 5.71 65.31 7.59 64.52 28.9 55.48 20.08 76.02 18.98 78.58 22.91 82.52 38.08 46.46 1.77 61.38"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "82.52 22.91 78.58 18.98 76.41 19.9 55.39 28.81 64.16 8.4 65.31 5.71 61.38 1.77 46.21 37.84 82.52 22.91"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M39.22,42.15a2.93,2.93,0,1,0,2.93-2.93A2.93,2.93,0,0,0,39.22,42.15Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2ec510ef81de53b33b4a32ddaf89ea35.svg";
export { ForwardRef as ReactComponent };